import { BemHelper } from "../../utils";
import React from "react";
import classNames from "classnames";

const bem = new BemHelper("spiner-ai");

type Props = {
  width?: string;
  type?: "color" | "pink";
  active?: boolean;
};

export const SpinerAi: React.FC<Props> = ({ width = 100, type = "pink", active = true }) => {
  return (
    <div className={classNames(bem.block())} style={{ height: width + "px" }}>
      <svg
        width={width}
        height={width}
        viewBox='0 0 32.1 27.2'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <linearGradient
          id='SVGID_1_'
          gradientUnits='userSpaceOnUse'
          x1='4.8245'
          y1='17.1162'
          x2='11.329'
          y2='17.9997'
          gradientTransform='matrix(1 0 0 -1 0 26)'
        >
          {type === "color" && (
            <>
              <stop offset='0' stopColor='#D58405' />
              <stop offset='0.5373' stopColor='#F39C12' />
              <stop offset='1' stopColor='#EEB457' />
            </>
          )}
          {type === "pink" && (
            <>
              <stop offset='0' stopColor='#BE64C0' />
              <stop offset='1' stopColor='#F7956C' />
            </>
          )}
        </linearGradient>
        <path
          id='spiner-ai-element-1'
          fill='url(#SVGID_1_)'
          d='M8.6,2.2c0.9,2.4,3.4,4.9,5.7,5.6c0.4,0.1,1.1,0.3,1.1,0.6c0,0.3-0.7,0.5-1.1,0.6
	c-2.4,0.8-4.9,3.4-5.7,5.8C8.4,15.3,8.2,16,7.9,16c-0.3,0-0.5-0.7-0.7-1.2c-0.9-2.6-3.8-5-5.8-5.8C1.2,8.9,0.5,8.7,0.5,8.4
	c0-0.3,0.7-0.5,0.9-0.6c2.1-0.7,4.9-3.2,5.8-5.7c0.2-0.6,0.4-1.3,0.7-1.3C8.2,0.9,8.4,1.6,8.6,2.2z'
          style={{ animationPlayState: active ? "running" : "paused" }}
        />
        <linearGradient
          id='SVGID_00000165234206077623454880000017820586280384675479_'
          gradientUnits='userSpaceOnUse'
          x1='20.5961'
          y1='17.1764'
          x2='27.1007'
          y2='18.0599'
          gradientTransform='matrix(1 0 0 -1 0 26)'
        >
          {type === "color" && (
            <>
              <stop offset='0' stopColor='#A98273' />
              <stop offset='0.5208' stopColor='#C6978C' />
              <stop offset='1' stopColor='#D8B8AB' />
            </>
          )}
          {type === "pink" && (
            <>
              <stop offset='0' stopColor='#BE64C0' />
              <stop offset='1' stopColor='#F7956C' />
            </>
          )}
        </linearGradient>
        <path
          id='spiner-ai-element-2'
          fill='url(#SVGID_00000165234206077623454880000017820586280384675479_)'
          d='M24.3,2.1c0.9,2.4,3.4,4.9,5.7,5.6
	c0.4,0.1,1.1,0.3,1.1,0.6c0,0.3-0.7,0.5-1.1,0.6c-2.4,0.8-4.9,3.4-5.7,5.8C24.2,15.2,24,16,23.7,16c-0.3,0-0.5-0.7-0.7-1.2
	c-0.9-2.6-3.8-5-5.8-5.8c-0.3-0.1-0.9-0.3-0.9-0.6c0-0.3,0.7-0.5,0.9-0.6c2.1-0.7,4.9-3.2,5.8-5.7c0.2-0.6,0.4-1.3,0.7-1.3
	C24,0.8,24.1,1.6,24.3,2.1z'
          style={{ animationPlayState: active ? "running" : "paused" }}
        />
        <linearGradient
          id='SVGID_00000174583739569914205180000017649336330797715126_'
          gradientUnits='userSpaceOnUse'
          x1='13.5537'
          y1='6.2706'
          x2='20.0583'
          y2='7.1542'
          gradientTransform='matrix(1 0 0 -1 0 26)'
        >
          {type === "color" && (
            <>
              <stop offset='0' stopColor='#2C3B38' />
              <stop offset='1' stopColor='#ADC8B6' />
            </>
          )}
          {type === "pink" && (
            <>
              <stop offset='0' stopColor='#BE64C0' />
              <stop offset='1' stopColor='#F7956C' />
            </>
          )}
        </linearGradient>
        <path
          id='spiner-ai-element-3'
          fill='url(#SVGID_00000174583739569914205180000017649336330797715126_)'
          d='M17.3,13c0.9,2.4,3.4,4.9,5.7,5.6
	c0.4,0.1,1.1,0.3,1.1,0.6c0,0.3-0.7,0.5-1.1,0.6c-2.4,0.8-4.9,3.4-5.7,5.8c-0.2,0.5-0.4,1.2-0.7,1.2c-0.3,0-0.5-0.7-0.7-1.2
	c-0.9-2.6-3.8-5-5.8-5.8c-0.3-0.1-0.9-0.3-0.9-0.6c0-0.3,0.7-0.5,0.9-0.6c2.1-0.7,4.9-3.2,5.8-5.7c0.2-0.6,0.4-1.3,0.7-1.3
	C16.9,11.7,17.1,12.5,17.3,13z'
          style={{ animationPlayState: active ? "running" : "paused" }}
        />
      </svg>
    </div>
  );
};
